import React from "react";

const LeftBottom = () => {
  return (
    <div className="leftbottom">
      <div className="x">
        <img src="./pp.jpg" alt="pp" />
        <div className="info">
          <h1>Full Name</h1>
          <p>@username</p>
        </div>
      </div>
      <button>
        <svg
          fill="rgb(231, 233, 234)"
          viewBox="0 0 24 24"
          aria-hidden="true"
          class="r-1nao33i r-4qtqp9 r-yyyyoo r-1xvli5t r-dnmrzs r-bnwqim r-1plcrui r-lrvibr"
        >
          <g>
            <path d="M3 12c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm9 2c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm7 0c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"></path>
          </g>
        </svg>
      </button>
    </div>
  );
};

export default LeftBottom;
